import React from 'react';
import cls from '../../utils/classnames';
import {
    KEYBOARD_TAB,
    KEYBOARD_TAB_TRANSPARENT,
    KEYBOARD_DEFAULT,
    KEYBOARD_TAB_ACTIVE
} from '../../utils/classes';
import './_styles.scss';


export interface ITabProps {
    active?: boolean;
    transparent?: boolean;
    children?: React.ReactChild | React.ReactChild[];
    onClick?: (event: React.MouseEvent<{}>) => void;
    className?: string;
    navigation?: { [key: string]: string };
    id?: string;
    onMouseEnter?: (event: React.MouseEvent<HTMLElement>) => void;
}

const rnd = () => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
};

export const Tab: React.FunctionComponent<ITabProps> = props => {
    const { active = false, transparent = false, children, onClick, className, navigation, id, onMouseEnter } = props;
    const navigationProps: any = {};
    if(navigation && typeof navigation.left !== 'undefined') {
        navigationProps['data-sn-left'] = navigation.left;
    }
    if(navigation && typeof navigation.right !== 'undefined') {
        navigationProps['data-sn-right'] = navigation.right;
    }
    if(navigation && typeof navigation.up !== 'undefined') {
        navigationProps['data-sn-up'] = navigation.up;
    }
    if(navigation && typeof navigation.down !== 'undefined') {
        navigationProps['data-sn-down'] = navigation.down;
    }
  return (
    <a
      id={id}
      {...navigationProps}
      href="javascript:void(0)"
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      className={cls(KEYBOARD_TAB, {
        [KEYBOARD_TAB_TRANSPARENT]: transparent,
        [KEYBOARD_DEFAULT]: !transparent,
        [KEYBOARD_TAB_ACTIVE]: active
      }, className)}
    >
      {children}
    </a>
  );
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/Keyboard/Tab/index.tsx